// import { Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import { LockReset, Refresh, VisibilityOutlined } from "@mui/icons-material";
// import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
// import LockOpenIcon from "@mui/icons-material/LockOpen";
// import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import RenderAction from "components/Action/RenderAction";

export default function TableData({
  onAction,
  data,
  rowsCount,
  curPage,
  actions = [],
  supportedActions = [],
}) {
  return {
    columns: [
      { name: "STT", align: "left", sortable: "true" },
      { name: "Tên đăng nhập", align: "left" },
      { name: "Tên người dùng", align: "left" },
      { name: "Số điện thoại", align: "left" },
      { name: "Vai trò", align: "left" },
      { name: "Email", align: "left" },
      { name: "Trạng thái", align: "left" },
      { name: "Thao tác", align: "left" },
    ],
    rows: data.map((item, index) => ({
      STT: (
        <SoftTypography
          style={{ fontSize: "16px" }}
          variant="caption"
          color="text"
          fontWeight="medium"
          title=""
        >
          {curPage * rowsCount + index + 1}
        </SoftTypography>
      ),
      "Tên đăng nhập": (
        <SoftTypography
          style={{ fontSize: "16px" }}
          variant="caption"
          color="text"
          fontWeight="medium"
          title=""
        >
          {item?.username !== null ? item.username : "---"}
        </SoftTypography>
      ),
      "Tên người dùng": (
        <SoftTypography
          style={{ fontSize: "16px" }}
          variant="caption"
          color="text"
          fontWeight="medium"
          title=""
        >
          {item?.fullName !== null ? item.fullName : "---"}
        </SoftTypography>
      ),
      "Số điện thoại": (
        <SoftTypography
          style={{ fontSize: "16px" }}
          variant="caption"
          color="text"
          fontWeight="medium"
          title=""
        >
          {item?.phone !== null ? item.phone : "---"}
        </SoftTypography>
      ),
      "Vai trò": (
        <SoftTypography
          style={{ fontSize: "16px" }}
          variant="caption"
          color="text"
          fontWeight="medium"
          title=""
        >
          {item?.roleName !== null ? item.roleName : "---"}
        </SoftTypography>
      ),
      Email: (
        <SoftTypography
          style={{ fontSize: "16px" }}
          variant="caption"
          color="text"
          fontWeight="medium"
          title=""
        >
          {item?.email !== null ? item.email : "---"}
        </SoftTypography>
      ),
      "Trạng thái": (
        <SoftBox
          alignItems="left"
          style={{
            display: "flex",
            alignItems: "left",
            backgroundColor: item.status === 0 ? "#FFF5F8" : "#E7FBED",
            borderRadius: "7px",
            padding: "2px 7px",
          }}
        >
          <SoftTypography
            style={{
              color: item.status === 0 ? "#B30000" : "green",
            }}
            fontWeight="medium"
            fontSize="14px"
            title=""
          >
            {item.status === 0 ? "Khóa" : "Hoạt động"}
          </SoftTypography>
        </SoftBox>
      ),
      "Thao tác": (
        <SoftBox display="flex" justifyContent="center">
          <RenderAction
            supportedActions={supportedActions}
            actions={actions}
            onAction={onAction}
            condition={{
              VIEW: true,
              EDIT: true,
              DELETE: true,
              LOCK: item.status === 1,
              UNLOCK: item.status === 0,
              RESETPASSWORD: true,
              RESET2FA: true,
            }}
            item={item}
          />
          {/* <Tooltip title="Xem chi tiết" placement="top">
            <VisibilityOutlined
              style={{ cursor: "pointer", marginRight: "8px" }}
              fontSize="small"
              onClick={() =>
                // handleOpenModalDetail(item)
                onAction({ item, mode: "VIEW" })
              }
              sx={{ color: "var(--blue-blue-100)" }}
            />
          </Tooltip>
          <Tooltip title="Chỉnh sửa" placement="top">
            <DriveFileRenameOutlineIcon
              style={{ cursor: "pointer", marginRight: "8px" }}
              fontSize="small"
              onClick={(e) => {
                e.stopPropagation(); // Ngăn chặn sự kiện click từ việc lan truyền lên
                onAction({ item, mode: "EDIT" });
              }}
              sx={{ color: "var(--blue-blue-100)" }}
            />
          </Tooltip>
          <Tooltip title="Xóa" placement="top">
            <DeleteOutlineIcon
              sx={{ color: "var(--blue-blue-100)" }}
              fontSize="small"
              style={{ cursor: "pointer", marginRight: "8px" }}
              onClick={(e) => {
                e.stopPropagation(); // Ngăn chặn sự kiện click từ việc lan truyền lên
                onAction({ item, mode: "DELETE" });
              }}
            />
          </Tooltip>
          <Tooltip title="Đặt lại mật khẩu" placement="top">
            <Refresh
              sx={{ color: "var(--blue-blue-100)" }}
              fontSize="small"
              style={{ cursor: "pointer", marginRight: "8px" }}
              onClick={(e) => {
                e.stopPropagation(); // Ngăn chặn sự kiện click từ việc lan truyền lên
                onAction({ item, mode: "RESET" });
              }}
            />
          </Tooltip>
          <Tooltip title="Đặt lại xác thực 2 bước" placement="top">
            <LockReset
              sx={{ color: "var(--blue-blue-100)" }}
              fontSize="small"
              style={{ cursor: "pointer", marginRight: "8px" }}
              onClick={(e) => {
                e.stopPropagation();
                onAction({ item, mode: "RESET_2FA" });
              }}
            />
          </Tooltip>

          {item.status === 1 ? (
            <Tooltip title="Khóa" placement="top">
              <LockOutlinedIcon
                sx={{ color: "var(--blue-blue-100)" }}
                fontSize="small"
                style={{ cursor: "pointer", marginRight: "8px" }}
                onClick={(e) => {
                  e.stopPropagation(); // Ngăn chặn sự kiện click từ việc lan truyền lên
                  onAction({ item, mode: "UNLOCK" });
                }}
              />
            </Tooltip>
          ) : (
            <Tooltip title="Mở khóa" placement="top">
              <LockOpenIcon
                sx={{ color: "var(--blue-blue-100)" }}
                fontSize="small"
                style={{ cursor: "pointer", marginRight: "8px" }}
                onClick={(e) => {
                  e.stopPropagation(); // Ngăn chặn sự kiện click từ việc lan truyền lên
                  onAction({ item, mode: "LOCK" });
                }}
              />
            </Tooltip>
          )} */}
        </SoftBox>
      ),
    })),
  };
}
TableData.propTypes = {
  onAction: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(Object).isRequired,
  rowsCount: PropTypes.number.isRequired,
  curPage: PropTypes.number.isRequired,
  actions: PropTypes.arrayOf(PropTypes.string),
  supportedActions: PropTypes.arrayOf(PropTypes.string),
};
